export const getLaborPortalCopy = (isArabic) => ({
  entry: isArabic
    ? {
        badgeText: 'إطلاق تجريبي',
        footerNote: 'هذه البوابة مخصصة لتقديم القضايا العمالية ومتابعتها بشكل منظم وآمن.',
        pill: 'بوابة القضايا العمالية',
        title: 'بوابة تقديم ومتابعة القضايا العمالية',
        description:
          'يمكنكم من خلال هذه البوابة تقديم الطلبات العمالية، متابعة الحالات السابقة، واستكمال البيانات والمستندات المطلوبة ضمن مسار منظم وواضح.',
        afterSubmission: 'ماذا ستحصلون بعد الإرسال؟',
        refBenefit: 'رقم مرجعي خاص بالطلب',
        trackBenefit: 'رابط متابعة مستقل وآمن',
        reviewBenefit: 'مراجعة من الفريق القانوني المختص',
        trust1: 'تتم مراجعة الطلبات من قبل الفريق القانوني المختص.',
        trust2: 'جميع البيانات والمرفقات تعامل بسرية تامة.',
        trust3: 'بوابة مخصصة لتقديم ومتابعة القضايا العمالية.',
        actions: {
          new: {
            title: 'تقديم طلب جديد',
            description: 'تعبئة البيانات وإرفاق المستندات المتعلقة بالقضية العمالية.',
            detail: 'بدء طلب جديد عبر نموذج منظم متعدد الخطوات.',
            button: 'بدء الطلب',
          },
          track: {
            title: 'متابعة طلب سابق',
            description: 'متابعة حالة الطلب باستخدام الرقم المرجعي أو رابط المتابعة.',
            detail: 'الاطلاع على الحالة الحالية ورفع المستندات الإضافية.',
            button: 'فتح المتابعة',
          },
          draft: {
            title: 'استكمال طلب',
            description: 'استكمال الطلب المحفوظ أو رفع المستندات والمعلومات المطلوبة.',
            detail: 'استرجاع المسودة المحفوظة أو استكمال النواقص المطلوبة.',
            button: 'فتح صفحة الاستكمال',
            resumeButton: 'استكمال المسودة',
            savedAt: 'آخر حفظ',
          },
        },
      }
    : {
        badgeText: 'Pilot Launch',
        footerNote: 'This portal is dedicated to submitting and tracking labor cases in a secure, organized manner.',
        pill: 'Labor Cases Portal',
        title: 'Labor Case Submission and Tracking Portal',
        description:
          'Through this portal, you can submit labor requests, track previous cases, and complete the required information and supporting documents through a clear and organized process.',
        afterSubmission: 'What will you receive after submission?',
        refBenefit: 'A dedicated reference number',
        trackBenefit: 'A secure private tracking link',
        reviewBenefit: 'Review by the specialized legal team',
        trust1: 'Requests are reviewed by the specialized legal team.',
        trust2: 'All data and attachments are handled confidentially.',
        trust3: 'A dedicated portal for labor case submission and tracking.',
        actions: {
          new: {
            title: 'Submit a New Request',
            description: 'Complete the form and attach documents related to the labor case.',
            detail: 'Start a new request through a structured multi-step form.',
            button: 'Start Request',
          },
          track: {
            title: 'Track a Previous Request',
            description: 'Track the request status using the reference number or tracking link.',
            detail: 'View the current status and upload any additional documents.',
            button: 'Open Tracking',
          },
          draft: {
            title: 'Complete a Saved Request',
            description: 'Resume a saved request or upload the required documents and information.',
            detail: 'Restore your saved draft or complete any requested missing items.',
            button: 'Open Resume Page',
            resumeButton: 'Resume Draft',
            savedAt: 'Last saved',
          },
        },
      },
});

export const laborStepsEn = {
  client: { title: 'Client Details', description: 'Basic information for communication and linking the request to its owner.' },
  company: { title: 'Employer Details', description: 'Information about the employer or company involved in the dispute.' },
  contract: { title: 'Contract and Relationship', description: 'Contract details, start date, and the current or ended relationship status.' },
  employment: { title: 'Employment Relationship, Wage, and Entitlements Analysis', description: 'Analyze the actual relationship, wage structure, leave, overtime, and core financial claims.' },
  notices: { title: 'Termination and Claims', description: 'Termination details, dispute correspondence, and the claims reported by the applicant.' },
  summary: { title: 'Summary of Data and Facts', description: 'An organized summary of the submitted data and facts before confirmation.' },
  attachments: { title: 'Attachments', description: 'Upload and organize the supporting documents related to the request.' },
  declaration: { title: 'Final Declaration and Submission', description: 'Final declaration of accuracy and approval to submit the request.' },
};

export const laborOptionMapsEn = {
  claims: {
    'أجور متأخرة': 'Delayed wages',
    'مكافأة نهاية خدمة': 'End-of-service award',
    'بدل إجازات': 'Unused leave compensation',
    'فصل تعسفي': 'Unfair dismissal',
    'عمولات': 'Commissions',
    'ساعات إضافية': 'Overtime pay',
    'بدل إنذار': 'Notice compensation',
    'شهادة الخدمة': 'Service certificate',
    'رصيد إجازات': 'Leave balance',
    'التعويض عن الأضرار': 'Compensation for damages',
    'تعويض فصل': 'Dismissal compensation',
    'بدل إشعار': 'Notice pay',
    'تذاكر': 'Tickets',
    'تعويض عن فصل غير مشروع': 'Compensation for unlawful dismissal',
    'بدل تذاكر': 'Ticket allowance',
    'بدل سكن': 'Housing allowance',
    'بدل نقل': 'Transport allowance',
    'بدل انتداب': 'Assignment allowance',
    'فروقات أجور': 'Wage differences',
    'إخلاء طرف': 'Clearance letter',
    'أخرى': 'Other',
  },
  evidence: {
    'إشعارات الفصل أو الإنهاء': 'Termination or dismissal notices',
    'رسائل واتساب': 'WhatsApp messages',
    'رسائل بريد إلكتروني': 'Email messages',
    'مسيرات رواتب': 'Payroll sheets',
    'كشف حساب بنكي': 'Bank statement',
    'خطابات أو تعاميم داخلية': 'Internal letters or circulars',
    'تكليفات عمل': 'Work assignments',
    'جداول دوام': 'Work schedules',
    'إثبات حضور وانصراف': 'Attendance and departure proof',
    'تسجيلات أو محادثات': 'Recordings or conversations',
    'عقود أو ملاحق': 'Contracts or addenda',
    'مخالفات أو جزاءات': 'Violations or penalties',
    'تقييمات أداء': 'Performance evaluations',
    'شهود': 'Witnesses',
    'صور أو مقاطع': 'Photos or videos',
    'مراسلات الموارد البشرية': 'HR correspondence',
    'أخرى': 'Other',
  },
  indicators: {
    'ساعات عمل محددة': 'Fixed working hours',
    'دوام حضور وانصراف': 'Attendance and departure schedule',
    'مدير مباشر': 'Direct manager',
    'تعليمات يومية': 'Daily instructions',
    'إجازات بموافقة': 'Leave subject to approval',
    'استخدام أدوات المنشأة': 'Use of employer tools',
    'بريد أو هوية وظيفية': 'Company email or ID',
    'راتب شهري ثابت': 'Fixed monthly salary',
    'جزاءات أو إنذارات': 'Penalties or warnings',
  },
  notices: {
    'إنذار': 'Warning notice',
    'لفت نظر': 'Written notice',
    'قرار فصل': 'Termination decision',
    'إشعار عدم تجديد': 'Non-renewal notice',
    'استدعاء تحقيق': 'Investigation summons',
    'محضر تحقيق': 'Investigation report',
    'قرار خصم': 'Deduction decision',
    'مخالصة': 'Settlement release',
    'إخلاء طرف': 'Clearance letter',
    'إيميل رسمي': 'Official email',
    'رسائل واتساب': 'WhatsApp messages',
    'إشعار قوى أو تأمينات': 'Qiwa or GOSI notice',
  },
  select: {
    'عقد عمل': 'Employment contract',
    'عقد تعاون': 'Cooperation contract',
    'عمل جزئي': 'Part-time work',
    'عمل بالعمولة': 'Commission-based work',
    'تدريب': 'Training',
    'Freelancer / مستقل': 'Freelancer / Independent contractor',
    'بدون عقد مكتوب': 'No written contract',
    'لا أعلم': 'Not sure',
    'نعم': 'Yes',
    'لا': 'No',
    'قائمة': 'Active',
    'منتهية': 'Ended',
    'فصل': 'Dismissal',
    'استقالة': 'Resignation',
    'إنهاء باتفاق الطرفين': 'Termination by mutual agreement',
    'فسخ العقد بموجب المادة 80': 'Termination under Article 80',
    'فسخ العقد بموجب المادة 81': 'Termination under Article 81',
    'انتهاء عقد': 'Contract expiry',
    'عدم تجديد': 'Non-renewal',
    'ترك العمل بسبب عدم السداد': 'Left work due to non-payment',
    'ترك عمل': 'Leaving work',
    'إنهاء من الشركة': 'Termination by employer',
    'إغلاق المنشأة': 'Closure of the establishment',
    'اتفاق بين الطرفين': 'Mutual agreement',
    'ما زالت العلاقة قائمة': 'Relationship still active',
    'تحويل بنكي': 'Bank transfer',
    'نقداً': 'Cash',
    'جزء بنكي وجزء نقدي': 'Part bank / part cash',
    'لا يوجد راتب ثابت': 'No fixed salary',
    'شيكات': 'Cheques',
    'ورقي': 'Paper',
    'بريد إلكتروني': 'Email',
    'واتساب': 'WhatsApp',
    'خطاب رسمي': 'Formal letter',
    'منصة قوى': 'Qiwa platform',
    'منصة ودّي': 'Waddi platform',
    'مكتب العمل': 'Labor Office',
    'رسالة واتساب': 'WhatsApp message',
    'رسالة نصية': 'Text message',
    'داخل النظام': 'Inside the system',
    'شفهي': 'Verbal',
    'بعد استلام المستحقات': 'After receiving dues',
    'قبل استلام المستحقات': 'Before receiving dues',
    'جزء قبل وجزء بعد': 'Part before and part after',
    'ورقية': 'Paper-based',
    'إلكترونية': 'Electronic',
    'كلاهما': 'Both',
    'الرقم الوطني الموحد': 'Unified national number',
    'السجل التجاري': 'Commercial registration',
    'رقم وطني موحد': 'Unified national number',
    'سجل تجاري': 'Commercial registration',
    'ترخيص نشاط': 'Business license',
    'ترخيص مهني': 'Professional license',
    'شهادة استثمار': 'Investment certificate',
    'رقم منشأة التأمينات': 'GOSI establishment number',
    'رقم منشأة مكتب العمل': 'Labor office establishment number',
    'دوام كامل حضوري': 'Full-time onsite',
    'دوام جزئي': 'Part-time',
    'عمل مرن': 'Flexible work',
    'عمل عن بعد': 'Remote work',
    'شفتات': 'Shift work',
    'غير منتظم': 'Irregular schedule',
    'حضوري': 'Onsite',
    'عن بعد': 'Remote',
    'مختلط': 'Hybrid',
    'هجين': 'Hybrid',
    'جزئياً': 'Partially',
    'أحياناً': 'Sometimes',
    'إلى حد ما': 'To some extent',
    'مكتوبة': 'Written',
    'شفوية': 'Verbal',
    'أجر أساسي فقط': 'Basic wage only',
    'أجر شامل': 'Comprehensive wage',
    'أجر أساسي + بدلات': 'Basic wage + allowances',
    'بدل انتقال': 'Mobility allowance',
    'بدل اتصال': 'Communication allowance',
    'بدل طبيعة عمل': 'Nature-of-work allowance',
    'علاوة سنوية': 'Annual increment',
    'مكافآت دورية': 'Periodic bonuses',
    'عادية': 'Normal',
    'مرتفعة': 'High',
    'عاجلة جداً': 'Very urgent',
    'لا أذكر': 'I do not remember',
  },
};
